module.exports = __webpack_public_path__ + "media/assets/images/blog/wet_window-small-5922700764f10ec332f840e17d58464f.jpg";